// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useQuery } from '@tanstack/react-query';
import { useHttpClient, type HttpClientInstance } from '@toggl/sync/http';
import type {} from '../types';
import { createQueryOptions } from '../utils/queries';
import {
  getCustomerInvoicesQueryKey,
  getCustomerQueryKey,
  getInvoiceSummaryQueryKey,
  getSubscriptionQueryKey,
} from './keys';
import {
  getCustomer,
  getCustomerInvoices,
  getInvoiceSummary,
  getSubscription,
} from './requests';

/**
 * Gets the workspace subscription details from toggl subscription service
 */
export function getSubscriptionQueryOptions(
  httpClient: HttpClientInstance,
  workspace_id: number,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getSubscriptionQueryKey(workspace_id),
    queryFn: ({ signal }) => getSubscription(httpClient, workspace_id, signal),
    enabled,
  });
}
/**
 * Gets the workspace subscription details from toggl subscription service
 */
export function useGetSubscription(workspace_id: number, enabled?: boolean) {
  const httpClient = useHttpClient();
  return useQuery(
    getSubscriptionQueryOptions(httpClient, workspace_id, enabled)
  );
}

/**
 * Gets the current workspace customer that is used by toggl subscription service in stripe
 */
export function getCustomerQueryOptions(
  httpClient: HttpClientInstance,
  workspace_id: number,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getCustomerQueryKey(workspace_id),
    queryFn: ({ signal }) => getCustomer(httpClient, workspace_id, signal),
    enabled,
  });
}
/**
 * Gets the current workspace customer that is used by toggl subscription service in stripe
 */
export function useGetCustomer(workspace_id: number, enabled?: boolean) {
  const httpClient = useHttpClient();
  return useQuery(getCustomerQueryOptions(httpClient, workspace_id, enabled));
}

/**
 * Gets the workspace customer invoices from toggl subscription service
 */
export function getCustomerInvoicesQueryOptions(
  httpClient: HttpClientInstance,
  workspace_id: number,
  params?: { lastInvoiceId?: string; nextInvoiceID?: string },
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getCustomerInvoicesQueryKey(workspace_id, params),
    queryFn: ({ signal }) =>
      getCustomerInvoices(httpClient, workspace_id, params, signal),
    enabled,
  });
}
/**
 * Gets the workspace customer invoices from toggl subscription service
 */
export function useGetCustomerInvoices(
  workspace_id: number,
  params?: { lastInvoiceId?: string; nextInvoiceID?: string },
  enabled?: boolean
) {
  const httpClient = useHttpClient();
  return useQuery(
    getCustomerInvoicesQueryOptions(httpClient, workspace_id, params, enabled)
  );
}

/**
 * Calculates the current subscription plan price, if a subscription plan is passed as a query param the endpoint will calculate that subscription price
 */
export function getInvoiceSummaryQueryOptions(
  httpClient: HttpClientInstance,
  workspace_id: number,
  params?: { subscriptionPlan?: string },
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getInvoiceSummaryQueryKey(workspace_id, params),
    queryFn: ({ signal }) =>
      getInvoiceSummary(httpClient, workspace_id, params, signal),
    enabled,
  });
}
/**
 * Calculates the current subscription plan price, if a subscription plan is passed as a query param the endpoint will calculate that subscription price
 */
export function useGetInvoiceSummary(
  workspace_id: number,
  params?: { subscriptionPlan?: string },
  enabled?: boolean
) {
  const httpClient = useHttpClient();
  return useQuery(
    getInvoiceSummaryQueryOptions(httpClient, workspace_id, params, enabled)
  );
}
